import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalComponent } from 'src/app/modules/global/components/modals/confirmation-modal/confirmation-modal.component';
import { ToastService } from 'src/app/modules/shared/toast/toast.service';
import { GridNames } from '../../models/margin-modal';
import { MarginCalcStoreService } from '../../services/margincalc-store.service';
import { MarginService } from '../../services/margincalc.service';

@Component({
  selector: 'app-grid-data',
  standalone: false,
  templateUrl: './grid-data.component.html',
  styleUrls: ['./grid-data.component.scss']
})
export class GridDataComponent implements OnInit {
  public vh = window.innerHeight - 200;
  gridNames: GridNames[] = [];
  loading: boolean = false;
  constructor(private service: MarginService, private router: Router, private toastService: ToastService,
    private modalService: NgbModal, public storeService: MarginCalcStoreService) { }

  ngOnInit(): void {
    this.loading = true;
    this.service.getMarginCalculatorGridNames().subscribe((res) => {
      this.gridNames = res.GridNames;
      this.loading = false;
    });
  }

  ConfirmDelete(batchId: number) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
      backdrop: 'static'
    });    
      modalRef.componentInstance.message = 'Are you sure want to delete?';
      modalRef.result.then(result => result === 'Delete' ? (this.DeleteGridName(batchId)) : null);
  }
  DeleteGridName(batchId:number) {
    this.loading = true;
    this.service.deleteMarginCalculatorGridName(batchId).subscribe((res) => {
      if(res.Message === 'Success') {
        this.loading = false;
        this.toastService.show('Deleted successfully');
        this.loading = true;
        this.service.getMarginCalculatorGridNames().subscribe((res) => {
          this.gridNames = res.GridNames;
          this.loading = false;
        });
      }
      else {
        this.loading = false;
        this.toastService.show(res.Message);        
      }
    })
  }
  EditMarginData(batchId:number) {
    this.storeService.gridId = batchId;
    this.router.navigateByUrl('margin-calcuator');
  }
  BackToMarginCalculator() {
    this.storeService.gridId = 0;
    this.router.navigateByUrl('margin-calcuator');
  }
}
